import { render, staticRenderFns } from "./academic_work_group.vue?vue&type=template&id=6e5c9c82"
import script from "./academic_work_group.vue?vue&type=script&lang=js"
export * from "./academic_work_group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports